export default "__VITE_ASSET__cwWSAdkT__"